/**
 * Created by Sina Khelil on 2/20/15.
 */

angular
  .module('capability-ng-scheduler')
  .factory('CommitmentRangeBuilder', function CommitmentRangeBuilder(Interface: any) {
    const DTD = {
      commitment_value: 'integer',
      prefs_first_visit: 'boolean'
    };

    function CommitmentRangeDTO(this: any, data: any) {
      Interface.implement(DTD, data, this);
    }

    return CommitmentRangeDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/builders/commitment_range_builder.ts